<template>
  <div id="app" class="helvetica">
    <header class="" style="z-index: 2;">
      <nav class="dt w-100 w-100-m w-half-ns w-half-l border-box f1 f1-ns">
        <!-- <router-link class="link w-100 black di outline-0 lh-solid" title="Home" to="/"><img class="logo" src="@/assets/logo.png"></router-link><br/> -->
        <router-link
          class="link w-100 white di outline-0 lh-solid"
          title="Home"
          to="/"
          >Mario Guay</router-link
        ><br />
        <router-link
          class="link w-100 white di outline-0 lh-solid"
          title="Home"
          to="/"
          >{{ documentTitle }}</router-link
        ><br />
        <router-link
          class="nav-info link w-100 di green outline-0 lh-solid"
          to="/about"
          >About</router-link
        >
      </nav>
    </header>
    <div class="gradient"></div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      documentTitle: ''
    };
  },
  created() {
    const self = this;
    this.$store.dispatch('fetchMetaInformation', {
      vm: this,
      cb: function(results) {
        // console.log(results[0].data.site_title);
        self.documentTitle = results[0].data.site_title;
      }
    });
  },
  metaInfo() {
    return {
      title: 'Mario Guay - ' + this.documentTitle,
      meta: [
        { property: 'og:title', content: this.documentTitle },
        { property: 'og:site_name', content: this.documentTitle },
        { property: 'og:type', content: 'website' }
      ]
    };
  }
};
</script>

<style>
@font-face {
  font-family: 'helvetica-ext';
  src: url('./assets/fonts/helveticaneue-extended-webfont.woff2')
      format('woff2'),
    url('./assets/fonts/helveticaneue-extended-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

.helvetica-ext {
  font-family: 'helvetica-ext', helvetica neue, helvetica, sans-serif !important;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
main,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0px;
  padding: 0px;
  border: 0px;
  font: inherit;
  vertical-align: baseline;
}

html {
  scroll-behavior: smooth;
}

body {
  overscroll-behavior: none;
  overflow-x: hidden;
  /*background-color: rgb(128, 128, 128);*/
  /* background-color: #4D4D4D; */
  /* background: rgb(0,0,0);
  background: linear-gradient(180deg, rgba(0,0,0,1) 40%, rgba(0,255,0,1) 100%); */
}

.gradient {
  position: fixed;
  top: 0%;
  right: 0%;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 255, 0, 1) 100%
  );
}

img {
  outline: none;
}

.link:focus {
  outline: none;
}

.tippy-popper {
  transition: all 0s ease 0s !important;
}
.tippy-backdrop {
  background-color: transparent !important;
}
.tippy-tooltip {
  color: #00ff00 !important;
  font-size: 2em !important;
  font-family: helvetica neue, helvetica, sans-serif !important;
}

nav {
  /*padding: 1rem 0 0 1.5rem;*/
  position: fixed;
  z-index: 100000;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  user-select: none;
  left: 0px;
  width: 100%;
  height: var(--ms2);
  top: 0px;
  bottom: auto;
}

.nav-info.router-link-exact-active {
  /*opacity: 0;*/
  display: none;
}

.logo {
  max-width: 262px;
  margin-bottom: -17px;
  margin-left: 3px;
  position: relative;
  z-index: 100;
}

/*.logo {
  width: 262px;
  height: 63px;
  margin-bottom: -13px;
  margin-left: 3px;
  background-image: url(./assets/logo.png);
  background-size: contain;
  background-blend-mode: difference;
}*/

.green {
  color: rgb(0, 255, 0);
}
.b--green {
  border-color: rgb(0, 255, 0);
}
/*.grey { color: rgb(128, 128, 128); }*/
.grey {
  color: #4d4d4d;
}
.light-grey {
  color: rgb(153, 153, 153);
}

.hyphenate {
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

::selection {
  background: rgb(0, 255, 0); /* WebKit/Blink Browsers */
  color: rgb(128, 128, 128);
}
::-moz-selection {
  background: rgb(0, 255, 0); /* Gecko Browsers */
  color: rgb(128, 128, 128);
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

@media screen and (max-width: 320px) {
  .f1 {
    font-size: 2.25rem;
  }
}
</style>
